
// @ts-nocheck





import { i18nText } from '@/locales';


import {mixins} from "vue-class-component";
import {Component, Prop, Emit, Vue} from "vue-property-decorator";
import {SalonsMix} from "@/UI/mixins/SalonsMix";
import {SalonsStore} from "@/store/modules/Salons";
import {PaginationMix} from "@/UI/mixins/PaginationMix";
import {Select, Tooltip, Drawer} from "ant-design-vue";
import {FormMix} from "@/UI/mixins/FormMix";
import {Pagination} from "ant-design-vue";
import {HandleScrollStore, SearchinStore} from "@/UI/Decorators/decorator";
import {isObjectsEqual} from "@/UI/lib/support";
import {showNotificationSimple} from "@/UI/lib/messages";

@Component({
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-tooltip": Tooltip,
    "a-drawer": Drawer,
  },
  methods: {isObjectsEqual},
})
export default class StudioSelect extends mixins(FormMix, SalonsMix, PaginationMix) {
  @Prop() picked!: boolean;
  //@Prop() selected!: boolean
  loading: boolean;
  searchHandle: number;
  fetchedByDrop: boolean = false;
  isOpen: boolean;
  visible: boolean;
  //dataSearch: Array<ISalonsListItem> = [];
  value: string;
  StudioId = 0;

  /*scrollPage = 1;
  totalRecords = 0;
  sourceLength = 0;*/

  constructor() {
    super();
    this.visible = false;
    this.isOpen = false;
    this.loading = true;
    this.searchHandle = 0;
    this.value = "";
  }

  @Emit()
  NumberChange(evt: any): void {
    this.value = evt;
    console.log(evt);
  }

  @SearchinStore
  hSearch(source: string, value: string): void {
  }

  @HandleScrollStore
  hScroll(event: any, value: string): void {
  }

  handleSearch(source: string): void {
    this.hSearch("salons", source);
  }

  handleScroll(event: any): void {
    this.hScroll(event, "salons");
  }

  async onDropHandler(open: boolean): Promise<void> {
    if (!this.fetchedByDrop) {
      try {
        this.loading = true;
        await SalonsStore.fetchAll({
          limit: 10,
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.fetchedByDrop = true;
        this.loading = false;
      }
    }
  }

  async created(): Promise<void> {
    try {
      this.loading = false;
      if (this.$router.currentRoute.params["Studio"]) {
        this.StudioId = Number(this.$router.currentRoute.params["Studio"]);
      } else {
        this.StudioId = this.$store.state.salon_id;
      }

      await SalonsStore.fetchAll({
        limit: this.AppPageParams.pageSize,
        filter: this.StudioId ? {id: this.StudioId} : {}
      });

      if (this.salons) {
        this.value = this.salons.data[0].name;
      }
      //this.constructDataSearch();
    } catch (e) {
      console.log("Error loading salons data");
    } finally {
      this.loading = true;
    }
  }

  customRow = (record: any) => {
    return {
      on: {
        click: (event: any) => {
          console.log("send Event -" + record.id);
          this.changeSalon(record.id);
          this.NumberChange(record.name);
          //this.value = record.name;
        },
      },
    };
  };

  async changeSalon(id: number): Promise<void> {
    //TODO::изменить у текущего пользователя salon_id
    this.StudioId = id;
    //если у текущего маршрута есть Studio заменить на текущий

    if (this.$router.currentRoute.params["Studio"]) {
      const params = { ...this.$router.currentRoute.params };
      params["Studio"] = String(id);
      if (params.filter) params.filter = JSON.stringify({ salon_id: id });

      const existParams = {
        name: Vue.router.app.$route.name,
        params: Vue.router.app.$route.params,
      };
      const newParams = {
        name: Vue.router.app.$route.name,
        params: params,
      };
      if (!isObjectsEqual(newParams, existParams)) {
        await Vue.router.replace({
          name: String(Vue.router.app.$route.name),
          params: params,
        });
      }
    }
    this.$store.commit("changeSalon", id);
    showNotificationSimple(i18nText("Внимание"), i18nText("Студия изменена !"), 1);
  }

  handleChange(value: any): void {
    this.value = value;
    this.changeSalon(value);
  }

  handleTableChange(pagination: Pagination, filters: any, sorter: any): void {
    this.tableLoad = false;
    SalonsStore.fetchAll({skip: this.calcSkip(pagination), limit: pagination.pageSize});
    this.tableLoad = true;
  }
}
